import { render, staticRenderFns } from "./SubscriptionResult.vue?vue&type=template&id=56f186be&scoped=true"
import script from "./SubscriptionResult.vue?vue&type=script&lang=ts"
export * from "./SubscriptionResult.vue?vue&type=script&lang=ts"
import style0 from "./SubscriptionResult.vue?vue&type=style&index=0&id=56f186be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f186be",
  null
  
)

export default component.exports